import { render } from "./NotesAssistant.vue?vue&type=template&id=731f5efe&scoped=true"
import script from "./NotesAssistant.vue?vue&type=script&lang=js"
export * from "./NotesAssistant.vue?vue&type=script&lang=js"

import "./NotesAssistant.vue?vue&type=style&index=0&id=731f5efe&scoped=true&lang=css"

import exportComponent from "D:\\phpstudy_pro\\data.yuandiansiyu.com\\platform_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-731f5efe"]])

export default __exports__